import { render } from "./CostChart.vue?vue&type=template&id=495eb6a3&scoped=true"
import script from "./CostChart.vue?vue&type=script&lang=js"
export * from "./CostChart.vue?vue&type=script&lang=js"

import "./CostChart.vue?vue&type=style&index=0&id=495eb6a3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-495eb6a3"]])

export default __exports__